import type {LocalisedPropertyValue} from '../types/shared-types';

export const getLocalisedPropertyValue = (
  value: LocalisedPropertyValue,
  language: 'en' | 'de'
): string => {
  if (language === 'de') {
    return value.de.trim() || value.en.trim() || '';
  }
  return value.en.trim() || value.de.trim() || '';
};
